import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch('http://localhost:8000/api/token-auth/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        setError('Invalid username or password.');
        return;
      }

      const data = await response.json();
      const { token, user } = data;

      if (!token || !user) {
        setError('Authentication failed. Please try again.');
        return;
      }

      // ✅ Store token in localStorage
      localStorage.setItem('authToken', token);

      // ✅ Save user context
      login(token, null, null, user);

      // ✅ Redirect based on user type
      if (user.is_superuser || user.is_staff) {
        navigate('/dashboard');
      } else {
        // Default all freelancers to dashboard too
        navigate('/dashboard');
      }

    } catch (err) {
      console.error('❌ Login error:', err);
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <div style={{ padding: '2rem', maxWidth: 400, margin: 'auto' }}>
      <h2>Login</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          style={{ width: '100%', marginBottom: 10 }}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{ width: '100%', marginBottom: 10 }}
        />
        <button type="submit" style={{ width: '100%' }}>
          Login
        </button>
      </form>
    </div>
  );
};

export default LoginPage;